import { observer } from 'mobx-react';
import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector, { timelineConnectorClasses } from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';

import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import TimelinePageStore from './store/TimelinePageStore';
import { useLocation } from 'react-router-dom';
import { useRootStore } from 'store/StoreContextProvider';
import { AssessModel } from 'domains/models/AssessModel';
import { CircularProgress, Divider, Grid } from '@mui/material';
import BasicImage from 'pages/MyPage/component/BasicImage';

import bluePin from '../../assets/image/bluePin.png';
import redPin from '../../assets/image/redPin.png';
import CommentViewModal from './component/CommentViewModal';

interface Props {
  pageStore: TimelinePageStore;
}
function TimelinePageListView(props: Props) {
  const { pageStore } = props;
  const { headerStore } = useRootStore();

  const location = useLocation();
  // const employee = location.state.employee;

  const onHandleClick = (assess: AssessModel) => {
    pageStore.setAssess(assess);
    pageStore.fetchTaskByAssessId(assess.parentId!);
    pageStore.setIsOpenModal(true);
  };

  React.useEffect(() => {
    headerStore.setPageTitle('Summary');
    // pageStore.fetchAsssessList(employee.id);
  }, []);

  const renderTitle = (assess: AssessModel, task: any) => {
    if (task.subtype === 'CHAT') {
      if (task.userData?.body?.contentType === 'html') {
        let content = task.userData?.body?.content;

        content = content
          ?.split('<')
          .filter((el: any) => !el.startsWith('img'))
          .filter((el: any) => !el.startsWith('div>&nbsp'))
          ?.join('<');

        return (
          <div>
            <div
              style={{
                maxHeight: '49px',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '19px',
                color: '#171918',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              dangerouslySetInnerHTML={{
                __html: content as any,
              }}
            ></div>
          </div>
        );
      } else {
        return (
          <div
            style={{
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '19px',
              color: '#171918',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {task.userData?.body?.content}
          </div>
        );
      }
    } else {
      if (task.userData?.bodyPreview) {
        let content = task.userData?.body?.content?.split('<')[0];

        return (
          <div
            style={{
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '22px',
              color: '#171918',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {task.title}
            <div
              style={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17px',
                color: '#171918',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {task.userData?.bodyPreview.trim()}
            </div>
          </div>
        );
      }
      return (
        <div
          style={{
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '19px',
            color: '#171918',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {task.title}
        </div>
      );
    }
  };

  const renderLockIcon = (child: AssessModel) => {
    if (child.subtype === 'VISIBLE') {
      return <LockOpenIcon fontSize='small' />;
    } else {
      return <LockIcon fontSize='small' />;
    }
  };
  const renderPinIcon = (child: AssessModel) => {
    if (child.userData?.like === 'true') {
      return <img src={bluePin} alt='bluePin' />;
    } else if (child.userData?.like === 'false') {
      return <img src={redPin} alt='redPin' />;
    }
  };

  return (
    <Grid style={{ paddingBottom: '80px' }}>
      {pageStore.isLoading ? (
        <Grid container justifyContent={'center'} style={{ marginTop: '150px' }}>
          <CircularProgress />
        </Grid>
      ) : (
        <Timeline
          sx={{
            [`& .${timelineItemClasses.root}:before`]: {
              flex: 0,
              padding: 0,
            },
            [`& .${timelineConnectorClasses.root}`]: {
              background: '#E5E5E5',
            },
          }}
        >
          {pageStore.assessList &&
            pageStore.assessList.map((assess: AssessModel) => {
              return (
                <TimelineItem key={assess.id} onClick={() => onHandleClick(assess)}>
                  <TimelineSeparator>
                    <TimelineDot
                      style={{
                        width: '44px',
                        height: '44px',
                        cursor: 'pointer',
                        justifyContent: 'center',
                        alignItems: 'center',
                        background: assess.userData?.emoticon ? '#47D4FF55' : '#47D4FF11',
                        border: '1px solid #47D4FF',
                        boxShadow: 'none',
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      {assess.userData?.emoticon || ''}
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: '12px', px: 2, maxWidth: '600px' }}>
                    <Grid container alignItems={'center'} justifyContent={'space-between'}>
                      <Grid>
                        <Typography
                          style={{
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '12px',
                            marginBottom: '6px',
                          }}
                        >
                          {moment(assess.created).format('YYYY년 MM월 DD일')}
                        </Typography>
                      </Grid>
                      <Grid></Grid>

                      <Grid container justifyContent='right' alignItems='right' style={{ width: 120, textAlign: 'right' }}>
                        <Grid item>
                          {assess.subtype === 'VISIBLE' ? (
                            <Typography
                              style={{
                                padding: '3px 8px',
                                fontWeight: 500,
                                fontSize: '14px',
                                lineHeight: '14px',
                              }}
                            >
                              {assess.userData.grade}점
                            </Typography>
                          ) : (
                            ''
                          )}
                        </Grid>
                        <Grid item alignItems={'center'}>
                          {renderLockIcon(assess)}
                          {renderPinIcon(assess)}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      style={{
                        border: '1px solid #006DCE55',
                        marginTop: '5px',
                        marginBottom: '10px',
                        borderRadius: '15px',
                        padding: '16px',
                      }}
                      justifyContent={'space-between'}
                    >
                      <Grid>
                        <Grid
                          style={{
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '18px',
                            width: 'calc(100vw - 150px)',
                            maxWidth: '500px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {assess.parents && renderTitle(assess, assess.parents[0])}
                        </Grid>
                        <Grid
                          style={{
                            fontWeight: 400,
                            fontSize: '13px',
                            lineHeight: '17px',
                            marginTop: '4px',
                            width: 'calc(100vw - 150px)',
                            maxWidth: '500px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {assess.title}
                        </Grid>
                      </Grid>
                      <Grid>
                        <div style={{ marginTop: 15 }}>
                          {assess.user?.userData?.profile ? (
                            <BasicImage
                              src={assess.user?.userData?.profile}
                              style={{
                                width: 40,
                                height: 40,

                                borderRadius: '50%',
                                objectFit: 'cover',
                                overflow: 'hidden',
                              }}
                            />
                          ) : (
                            <Avatar>
                              <ImageIcon />
                            </Avatar>
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </TimelineContent>
                </TimelineItem>
              );
            })}
        </Timeline>
      )}

      <CommentViewModal pageStore={pageStore} />
    </Grid>
  );
}

export default observer(TimelinePageListView);
